// extracted by mini-css-extract-plugin
export var menuIcon = "_rl-0";
export var menuIconInline = "_rl-1";